// https://fluentsite.z22.web.core.windows.net/quick-start
import {
  FluentProvider,
  teamsLightTheme,
  teamsDarkTheme,
  teamsHighContrastTheme,
  Spinner,
  tokens,
} from "@fluentui/react-components";
import {
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { useTeamsUserCredential } from "@microsoft/teamsfx-react";
import Privacy from "./Privacy";
import TermsOfUse from "./TermsOfUse";
import Tab from "./Tab";
import { TeamsFxContext } from "./Context";
import config from "../config";
import { CostItemDetails } from "./CostItems/CostItemDetails/CostItemDetails";
import PendingItems from "./CostItems/PendingItems/PendingItems";
import OpenForBids from "./Candidates/OpenForBids";
import { Candidates } from "./Candidates/Candidates";
import HowTo from "./HowTo";
/**
 * The main app which handles the initialization and routing
 * of the app.
 */
export default function App() {
  const { loading, theme, themeString, teamsUserCredential } =
    useTeamsUserCredential({
      initiateLoginEndpoint: config.initiateLoginEndpoint!,
      clientId: config.clientId!,
    });

  return (
    <TeamsFxContext.Provider
      value={{ theme, themeString, teamsUserCredential }}
    >
      <FluentProvider
        theme={
          themeString === "dark"
            ? teamsDarkTheme
            : themeString === "contrast"
            ? teamsHighContrastTheme
            : {
                ...teamsLightTheme
              }
        }
        style={{ background: tokens.colorNeutralBackground3, height: '100%' }}
      >
       
          {loading ? (
            <Spinner style={{ margin: 100 }} />
          ) : (
            <Routes>
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/termsofuse" element={<TermsOfUse />} />
              <Route path="/tab" element={<Tab />} />
              <Route path="/pendingItems" element={<PendingItems />} />
              <Route path="/OpenForBids" element={<OpenForBids />} />
              <Route path="/candidates/:id/:name" element={<Candidates />} />
              <Route path="/costitemdetails/:id" element={<CostItemDetails />} />
              <Route path="/howto" element={<HowTo />} />
              <Route path="*" element={<Navigate to={"/tab"} />}></Route>
            </Routes>
          )}
        
      </FluentProvider>
    </TeamsFxContext.Provider>
  );
}
